import React, { useEffect, useRef, useState } from "react";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import axios from "axios";
import DynamicTable from "../../../../Extra/DynamicTable";

const DurationWiseReport = ({ data, startDate, endDate }) => {
  const Header = {
    caution_id: "caution_id",
    station_from: "station_from",
    station_to: "station_to",
    date_from: "date_from",
    date_to: "date_to",
    speed_pass: "speed_pass",
    speed_goods: "speed_goods",
    reason: "reason",
    no_of_days_since_imposition: "no_of_days_since_imposition",
    caution_id: "caution_id",
    department: "department",
    remarks: "remarks",
  };
  const Header2 = {
    caution_id: "caution_id",
    station_from: "station_from",
    station_to: "station_to",
    date_from: "date_from",
    speed_pass: "speed_pass",
    speed_goods: "speed_goods",
    reason: "reason",
    no_of_days_since_imposition: "no_of_days_since_imposition",
    caution_id: "caution_id",
    department: "department",
    remarks: "remarks",
    difdate: "difdate ",
  };
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [sec, setSec] = useState("ANA-NKJ");
  const [secData, setSecData] = useState([]);
  const [runningData, setRunningData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const key = [
    "section",
    "0_15_days",
    "15_30_days",
    "30_60_days",
    "60_90_days",
    "90_180_days",
    "more_than_180_days",
    "total_records",
  ];
  const key2 = [
    "caution_id",
    "station_from",
    "station_to",
    "date_from",
    "date_to",
    "speed_pass",
    "speed_goods",
    "reason",
    "no_of_days_since_imposition",
    "department",
    "remarks",
  ];

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getAllCautionOrder?start=${startDate}&end=${endDate}&section=${sec}`,
      );
      if (response.data.status === "ok") {
        setSecData(response.data.data);
      } else {
        setSecData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
  }, [sec, startDate, endDate]);

  const fetchedData2 = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getAllCautionOrderOpenTill?section=${sec}`,
      );
      if (response.data.status === "ok") {
        setRunningData(response.data.data);
      } else {
        setRunningData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData2();
  }, [sec]);

  const table = useRef();

  const sum = (column) => {
    return data.reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  // const avg = (column) => {
  //   const total = data.reduce((s, o) => s + Number(o[column] || 0), 0);
  //   return data.length ? (total / data.length).toFixed(2) : 0;
  // };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">Long Duration Caution</h6>
      <div className="table-responsive">
        <div>
          <table
            ref={table}
            className="table table-bordered table-striped text-center "
            style={{ fontSize: "13px" }}
          >
            <thead>
              <tr
                className="table-dark text-center align-middle"
                style={{ fontWeight: "bold" }}
              >
                <th> Sr No.</th>

                {key.map((Head, i) => (
                  <th
                    key={i}
                    style={{
                      whiteSpace: "normal",
                    }}
                  >
                    {Head.toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((o, i) => (
                  <tr
                    key={i}
                    onClick={() => setSec(o.section)}
                    className={sec === o.section ? "table-active" : ""}
                    style={{ cursor: "pointer" }}
                  >
                    <td> {i + 1}</td>
                    <td> {o["section"]}</td>
                    <td> {o["0_15_days"]}</td> <td> {o["15_30_days"]}</td>{" "}
                    <td> {o["30_60_days"]}</td> <td> {o["60_90_days"]}</td>{" "}
                    <td> {o["90_180_days"]}</td>{" "}
                    <td> {o["more_than_180_days"]}</td>{" "}
                    <td> {o["total_records"]}</td>
                  </tr>
                ))}
            </tbody>

            <tfoot>
              <tr className="table-dark fw-bold">
                <td colSpan={2}>Total</td>

                <td>{sum("0_15_days")}</td>
                <td>{sum("15_30_days")}</td>
                <td>{sum("30_60_days")}</td>
                <td>{sum("60_90_days")}</td>
                <td>{sum("90_180_days")}</td>
                <td>{sum("more_than_180_days")}</td>
                <td>{sum("total_records")}</td>
              </tr>

              {/* <tr className="table-dark fw-bold">
                <td colSpan={2}>Average</td>

                <td>{avg("0_15_days")}</td>
                <td>{avg("15_30_days")}</td>
                <td>{avg("30_60_days")}</td>
                <td>{avg("60_90_days")}</td>
                <td>{avg("90_180_days")}</td>
                <td>{avg("more_than_180_days")}</td>
                <td>{avg("total_records")}</td>
              </tr> */}
            </tfoot>
          </table>{" "}
          <div className="mb-3">
            <DownloadExcel
              tableRef={table}
              fileName={`Long Duration Caution Summary ${startDate} - ${endDate}`}
            />
          </div>
        </div>
      </div>{" "}
      <div
        className="row
      "
      >
        {secData && (
          <div>
            <div className="text-center bg-dark p-2 text-white ">
              <h5 className="text-center">
                {" "}
                Section Wise Caution Order Data
                <b style={{ color: "#b2b0b0ff" }}> ({sec})</b>
              </h5>
            </div>
            <div className="  bg-dark text-white pe-2 ps-2"> </div>
            <DynamicTable
              data={secData}
              headers={Header}
              rowsPerPage={10}
              fontSize={"12px"}
            />
          </div>
        )}
      </div>
      <div
        className="row
      "
      >
        {runningData && (
          <div>
            <div className="text-center bg-dark p-2 text-white ">
              <h5 className="text-center">
                {" "}
                Running Data Caution Order Data
                <b style={{ color: "#b2b0b0ff" }}> ({sec})</b>
              </h5>
            </div>
            <div className="  bg-dark text-white pe-2 ps-2"> </div>
            {/* <DynamicTable
              data={runningData}
              headers={remarkTableHeader}
              rowsPerPage={10}
              fontSize={"12px"}
            /> */}
            <DynamicTable
              data={runningData.map((item) => {
                const today = new Date();
                const fromDate = new Date(item.date_from);

                const diffTime = today - fromDate;
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                return {
                  ...item,
                  difdate: diffDays === 20502 ? "-" : diffDays,
                };
              })}
              headers={Header2}
              rowsPerPage={10}
              fontSize={"12px"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DurationWiseReport;
